import { useEffect } from "react";
import { useTheme } from "next-themes";

/**
 * Automatically applies the correct theme for the current role.
 * Call this hook at the top of student and teacher layout/page roots.
 */
export function useRoleTheme(role: "student" | "teacher") {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme(role === "student" ? "student" : "light");
  }, [role, setTheme]);
}
